import { CREDIT_CARD_MAP } from 'config/ui';

function creditCardValidator({ fieldValues, fields, msgs }) {
  const PAYMENT_CARD = 'PAYMENT_CARD';
  const cardTypeField = fields.appRequest_linkedPaymentCard_cardNetwork;
  const cardType = fieldValues.appRequest_linkedPaymentCard_cardNetwork;
  const fundingMethod = fieldValues.appRequest_fundingMethod;
  const ccNumber = fieldValues.appRequest_linkedPaymentCard_accountNumber;

  const isValidLength = () => {
    const creditcardNumber = ccNumber.replace(/ /g, '');
    if (fieldValues.appRequest_linkedPaymentCard_cardNetwork === CREDIT_CARD_MAP.amex) {
      return creditcardNumber.length === 15;
    }
    return creditcardNumber.length === 16;
  };

  if (!cardTypeField || !cardType || !fundingMethod) {
    return null;
  }
  if (fundingMethod === PAYMENT_CARD) {
    if (!cardTypeField?.lookupValues[cardType]) {
      if (msgs && msgs.ccSupportedNetworkMsg) {
        return msgs.ccSupportedNetworkMsg;
      }
      return 'This Credit card type is not supported.';
    }
    if (!isValidLength()) {
      if (msgs && msgs.ccLengthMsg) {
        return msgs.ccLengthMsg;
      }
      return 'Please enter the full card number provided in front of your card';
    }
  }
  return null;
}

export default creditCardValidator;
